<template>
  <div class="max-w-4xl px-4 py-12 mx-auto">
    <div class="p-8 border shadow-2xl bg-gray-900/80 backdrop-blur-lg border-gray-800/50 rounded-3xl animate-fade-in-up">
      <h1 class="mb-8 text-4xl font-bold text-white">{{ $t('footer.legal.privacy') || 'Privacy Policy' }}</h1>
      
      <div class="space-y-6 leading-relaxed text-gray-300">
        <p>{{ $t('privacy.intro') }}</p>
        
        <h2 class="mt-8 text-2xl font-semibold text-white">{{ $t('privacy.sections.collect.title') }}</h2>
        <p>{{ $t('privacy.sections.collect.desc') }}</p>
        <ul class="pl-6 space-y-2 list-disc">
          <li v-for="(item, i) in $t('privacy.sections.collect.items')" :key="i" v-html="item"></li>
        </ul>

        <h2 class="mt-8 text-2xl font-semibold text-white">{{ $t('privacy.sections.use.title') }}</h2>
        <p>{{ $t('privacy.sections.use.desc') }}</p>
        <ul class="pl-6 space-y-2 list-disc">
          <li v-for="(item, i) in $t('privacy.sections.use.items')" :key="i" v-html="item"></li>
        </ul>

        <h2 class="mt-8 text-2xl font-semibold text-white">{{ $t('privacy.sections.contact.title') }}</h2>
        <p>{{ $t('privacy.sections.contact.desc') }}</p>
      </div>

      <div class="mt-10">
        <button @click="$router.back()" class="flex items-center gap-2 px-6 py-2.5 text-sm font-semibold text-white transition-all duration-300 bg-gray-800 border border-gray-700 rounded-xl hover:bg-gray-700 hover:-translate-y-0.5 shadow-lg">
          <i class="fa fa-arrow-left"></i> {{ $t('previous') || 'Back' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyView'
}
</script>